import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import Button from 'yoda-core-components/lib/components/Button';
import Checkbox from 'yoda-core-components/lib/components/CheckBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import InputValidate from 'yoda-account-components/lib/components/InputValidate/InputValidate';
import { signinEmailRegExp } from '../../common/Constants';
import * as styles from './EmailShareList.css';

const cx = classNames.bind(styles);
class EmailShareList extends Component {
    static propTypes = {
        send: PropTypes.func.isRequired,
        messagesTexts: PropTypes.oneOfType([PropTypes.object]),
        shareList: PropTypes.oneOfType([PropTypes.object]),
        isDisabled: PropTypes.bool,
        emailSent: PropTypes.bool,
    };

    static defaultProps = {
        messagesTexts: {},
        shareList: {},
        isDisabled: false,
        emailSent: false,
    };

    constructor() {
        super();
        this.state = {
            errorMessage: null,
            messageLength: 0,
            msgLenghtExceeded: false,
            inputErrorClass: '',
            errorEmailClass: '',
            emailFocused: '',
            yourMessageFocused: '',
        };
        this.sendEmailCopy = {};
        this.listenToInput = this.listenToInput.bind(this);
        this.sendListClicked = this.sendListClicked.bind(this);
        this.onEmailFocus = this.onEmailFocus.bind(this);
        this.onEmailBlur = this.onEmailBlur.bind(this);
        this.onYourMessageFocus = this.onYourMessageFocus.bind(this);
        this.onYourMessageBlur = this.onYourMessageBlur.bind(this);
    }

    /* jshint ignore:start */
    /*eslint-disable*/
    /* istanbul ignore next */
    listenToInput() {
        this.props.closeMessageBox();
        const messageLength = this.message.value.length;
        const msgLenghtExceeded = messageLength > 250;
        this.setState({ messageLength, msgLenghtExceeded });
    }
    /* jshint ignore:start */
    /*eslint-disable*/
    /* istanbul ignore next */
    onEmailFocus() {
        if (this.state.emailFocused === '') {
            this.setState({ emailFocused: 'focused-label' });
        }
    }
    /* jshint ignore:start */
    /*eslint-disable*/
    /* istanbul ignore next */
    isEmailValueEmpty = () => (this.email.value || '').trim().length === 0;

    /* jshint ignore:start */
    /*eslint-disable*/
    /* istanbul ignore next */
    onEmailBlur() {
        const stateValue = {};
        if (this.isEmailValueEmpty()) {
            stateValue.emailFocused = '';
        } else {
            this.props.closeMessageBox();
        }
        if (this.state.errorMessage) {
            stateValue.errorMessage = null;
            stateValue.inputErrorClass = '';
        }
        this.setState(stateValue);
    }
    /* jshint ignore:start */
    /*eslint-disable*/
    /* istanbul ignore next */
    onYourMessageFocus() {
        if (this.state.yourMessageFocused === '') {
            this.setState({ yourMessageFocused: 'focused-label' });
        }
    }
    /* jshint ignore:start */
    /*eslint-disable*/
    /* istanbul ignore next */
    isYourMessageValueEmpty = () => (this.message.value || '').trim().length === 0;

    /* jshint ignore:start */
    /*eslint-disable*/
    /* istanbul ignore next */
    onYourMessageBlur() {
        if (this.isYourMessageValueEmpty()) {
            this.setState({ yourMessageFocused: '' });
        }
    }

    /* eslint-enable */
    /* jshint ignore:end */
    /* istanbul ignore next */
    sendListClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        const { enterEmailErrMsg, validEmailErrMsg } = this.props.messagesTexts;
        let emailValue = this.email.value;
        let validate = true;
        if (!emailValue) {
            validate = false;
            this.setState({
                errorMessage: enterEmailErrMsg,
                inputErrorClass: 'inputEmptyError',
                errorEmailClass: 'errorEmail',
            });
        } else {
            emailValue = emailValue.replace(/\s/g, '');
            const emailList = emailValue.split(',');
            for (let idx = 0; idx < emailList.length; idx += 1) {
                if (!signinEmailRegExp.test(emailList[idx])) {
                    validate = false;
                    this.setState({
                        errorMessage: validEmailErrMsg,
                        inputErrorClass: 'inputEmailError',
                        errorEmailClass: 'errorEmail',
                    });
                    break;
                }
            }
        }
        if (validate) {
            this.props.send(emailValue.split(','), this.message.value, this.sendEmailCopy.checked);
        }
    }

    handleKeyDown = (e) => {
        e.target.style.height = 'inherit';
        e.target.style.height = `${e.target.scrollHeight}px`;
    };

    /* istanbul ignore next */
    onInputChange = (input, isValid, value) => {
        const { enterEmailErrMsg, validEmailErrMsg } = this.props.messagesTexts;
        let emailValue = this.email.value;
        if (!emailValue) {
            this.setState({
                errorMessage: enterEmailErrMsg,
            });
        } else {
            emailValue = emailValue.replace(/\s/g, '');
            const emailList = emailValue.split(',');
            for (let idx = 0; idx < emailList.length; idx += 1) {
                if (
                    emailList[idx] &&
                    (emailList[idx].length === 1 || !signinEmailRegExp.test(emailList[idx]))
                ) {
                    this.setState({
                        errorMessage: validEmailErrMsg,
                    });
                } else if (!emailList[idx]) {
                    this.setState({
                        errorMessage: enterEmailErrMsg,
                    });
                } else {
                    this.setState({
                        errorMessage: null,
                    });
                }
            }
        }
    };

    render() {
        const {
            messagesTexts,
            shareList: { isLoading },
            isDisabled,
            emailSent,
        } = this.props;
        const {
            checkBoxLabel,
            newHeader,
            enterEmailHead,
            sendButtonLabel,
            infoPurpose,
            newEmailPlaceholder,
            yourMessage,
        } = messagesTexts || {};
        const labelData = () => (
            <span className={dt(['text-medium', 'text-black'])}>{checkBoxLabel}</span>
        );

        const loaderStyles = dt([
            'flex',
            'justify-center',
            'items-center',
            'top-0',
            'right-0',
            'bottom-0',
            'left-0',
            'h-6',
            'w-6',
            'after:content-[""]',
            'after:opacity-70',
            'after:w-6',
            'after:h-6',
            'after:block',
            'after:rounded-full',
            'after:border-[3px]',
            'after:border-solid',
            'after:border-gray-15',
            'after:border-t-black',
            'after:animate-loaderRotate',
        ]);

        const labelStyle = dt([
            'before:sm:!w-6',
            'before:sm:!h-6',
            'before:!mr-3',
            'after:sm:!w-[7px]',
            'after:sm:!h-[13px]',
            'after:sm:!top-1',
            'after:sm:!left-2',
        ]);

        /* istanbul ignore next */
        if (emailSent) {
            this.email.value = '';
            this.message.value = '';
        }
        return (
            <div className={cx('emailShareList')}>
                <h2
                    className={dt(['text-xLg', 'text-black', 'leading-[32px]', 'mb-2'])}
                    data-automation-id="share-emai-heading"
                >
                    {newHeader}
                </h2>
                <h3 className={dt(['text-medium', 'text-black', 'mb-2'])}>{enterEmailHead}</h3>
                <div
                    className={`${cx('floating-input')} ${dt([
                        'float-left',
                        'w-full',
                        'relative',
                    ])}`}
                >
                    <InputValidate
                        isInputValidated={(valid, value) => this.onInputChange('', valid, value)}
                        emptyInputError={this.state.errorMessage}
                        defaultError={this.state.errorMessage}
                        placeHolder="To"
                        label={newEmailPlaceholder}
                        name="email"
                        type="email"
                        defaultValue=""
                        disableAutoComplete
                        convertLabelToAnimatingLegend
                        onFocus={this.onEmailFocus}
                        onBlur={this.onEmailBlur}
                        wrapperTheme={dt(['min-h-[75px]'])}
                        refCallBack={(component) => {
                            this.email = component;
                        }}
                        dataQmEncrypt
                    />
                    <div className={dt(['text-gray-60', 'text-small'])}>{infoPurpose}</div>
                </div>
                <div
                    className={`${cx('floating-textarea')} ${dt([
                        'float-left',
                        'w-full',
                        'relative',
                        'mt-6',
                        'grid',
                    ])}`}
                >
                    <label
                        htmlFor="message"
                        className={`${cx('label', this.state.yourMessageFocused)} ${dt([
                            !this.state.yourMessageFocused && 'italic',
                        ])}`}
                    >
                        {yourMessage}
                    </label>
                    <textarea
                        data-automation-id="share-email-custom-message"
                        type="text"
                        name="message"
                        onFocus={this.onYourMessageFocus}
                        onBlur={this.onYourMessageBlur}
                        className={dt([
                            'min-h-[120px]',
                            'w-full',
                            'border',
                            'border-solid',
                            'border-gray-60',
                            'rounded-lg',
                            'py-3',
                            'px-5',
                            'text-medium',
                            'text-black',
                            'resize-none',
                        ])}
                        ref={(component) => {
                            this.message = component;
                        }}
                        onInput={this.listenToInput}
                        onChange={this.handleKeyDown}
                        readOnly={isDisabled}
                        maxLength="250"
                        data-qm-encrypt="true"
                    />
                    <div className={dt(['text-right', 'text-small', 'text-gray-60', 'hidden'])}>
                        {this.state.msgLenghtExceeded && (
                            <span className={cx('infoIcon')}>
                                <img
                                    className={cx('iconImage')}
                                    src="/static-listing/assets/images/error.svg"
                                    alt="infoIcon"
                                />
                            </span>
                        )}
                        <span className={cx(this.state.msgLenghtExceeded ? 'error' : '')}>
                            {this.state.messageLength} / 250
                        </span>
                    </div>
                    <div className={`${cx('checkBoxContainer')} ${dt(['mt-4', 'h-6'])}`}>
                        <Checkbox
                            automationId="share-email"
                            id="emailMe"
                            name="emailMe"
                            ref={(component) => {
                                this.sendEmailCopy = component;
                            }}
                            label={labelData()}
                        />
                    </div>
                </div>
                <div className={dt(['clear-both', 'flex'])}>
                    <Button
                        automationId="share-email-send"
                        size="Md"
                        isDisabled={isDisabled}
                        onClick={this.sendListClicked}
                        className={dt(['my-6', '!w-full'])}
                    >
                        {isLoading ? (
                            <div
                                data-automation-id="share-by-email"
                                className={`${loaderStyles} ${dt(['top-0.5', 'relative'])}`}
                            />
                        ) : (
                            sendButtonLabel
                        )}
                    </Button>
                </div>
            </div>
        );
    }
}

export default EmailShareList;
